import React, { useState } from "react";

import { Autocomplete, Box, Button, Paper, Stack, TextField, Typography } from "@mui/material";
import { useTaskDealsSelect } from "store";
import { DealBase, IEmail, ISuggestion } from "store/types";

interface Props {
  onCancel: () => void;
  onSubmit: (suggestion: ISuggestion) => void;
  email: IEmail;
  onMoveWithAiExtraction: (email: IEmail, deal: DealBase) => void;
}

export const SelectDealContent: React.FC<Props> = ({ onCancel, onSubmit }) => {
  const deals = useTaskDealsSelect();
  const [deal, setDeal] = useState<DealBase | null>(null);

  return (
    <Box sx={{ ...style }}>
      <Box>
        <Typography sx={{ fontSize: "16px", color: "#0a3142", marginBottom: "5px" }}>Select deal</Typography>
        <Stack gap="20px" mb="20px">
          <Stack sx={{ backgroundColor: "#dae0e2", height: "1px", marginBottom: "14px" }} />
          <Autocomplete
            sx={{ width: 356 }}
            disableClearable={Boolean(deal)}
            options={deals}
            value={deal}
            getOptionLabel={(option) => option.title}
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {option.title}
              </li>
            )}
            PaperComponent={({ children }) => {
              return (
                <Paper
                  sx={{
                    position: "absolute",
                    backgroundColor: "white",
                    zIndex: "10",
                    width: "100%",
                    borderRadius: "10px",
                    "& .MuiAutocomplete-option": {
                      "&:hover": {
                        backgroundColor: "#edf1f9"
                      }
                    }
                  }}
                >
                  {children}
                </Paper>
              );
            }}
            onChange={(_, option) => option && setDeal(option)}
            renderInput={(params) => <TextField {...params} placeholder="Select" label="Deal" />}
          />
        </Stack>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }} gap="20px">
          <Button onClick={onCancel} variant="outlined">
            Close
          </Button>
          <Button disabled={!deal} onClick={() => deal && onSubmit({ id: deal.id, deal })} variant="contained">
            Apply
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "8px",
  backgroundColor: "#fff",
  padding: "30px"
};
